export default "__VITE_ASSET__BRvuNxwv__"